import * as React from 'react';
import s from './sub-categories-selector.scss';
import { SelectorButton } from '../selector-button';
import { Divider } from '@wix/design-system';
import type { WithTranslation as WithTranslationProps } from 'react-i18next';
import { composer } from '../../../component-decorators/composer';
import type {
  GetWebSolutionsByTagsResponse,
  SubCategory,
} from '@wix/ambassador-marketplace/types';
import type { MarketplaceStore } from '../../../component-decorators/with-marketplace-store';

export interface ISubCategoriesSelectorProps
  extends Partial<WithTranslationProps> {
  marketplaceStore?: MarketplaceStore;
  subCategories: SubCategory[];
  categoryName: string;
  categorySlug?: string;
  name: string;
}

export const dtoToSubCategoriesSelectorProps = (
  res: GetWebSolutionsByTagsResponse,
): ISubCategoriesSelectorProps => {
  const subCategories = res?.tagsAndSubCategories?.[0]?.subCategories;
  const categoryName = res?.tagsAndSubCategories?.[0].tag?.slug?.replace(
    /-/g,
    '_',
  );
  const name = res?.tagsAndSubCategories[0]?.tag?.name;
  return { subCategories, categoryName, name };
};

export const SubCategoriesSelector = composer()
  .withTranslation()
  .withMarketplaceStore()
  .compose(
    ({
      marketplaceStore,
      subCategories,
      categoryName,
      categorySlug,
      t,
    }: ISubCategoriesSelectorProps) => {
      const selectedSubCategories = marketplaceStore.route.subCategories;
      function isSelectorButtonSelected(slug: string) {
        return slug === 'all'
          ? selectedSubCategories === undefined
          : selectedSubCategories?.includes(slug);
      }

      return (
        <div
          data-testid="sub-categories-selector"
          className={s.subCategoriesSelector}
        >
          <SelectorButton
            key="all"
            name={t('category.filter-subcategory.all')}
            slug="all"
            isSelected={isSelectorButtonSelected('all')}
            categoryName={categoryName}
            categorySlug={categorySlug}
            subCategoriesCount={subCategories.length}
          />
          <div className={s.selectorsDivider}>
            <Divider direction="vertical" skin="light" />
          </div>
          {subCategories.map((subCategory) => (
            <SelectorButton
              key={subCategory.slug}
              name={subCategory.name}
              slug={subCategory.slug}
              isSelected={isSelectorButtonSelected(subCategory.slug)}
              categoryName={categoryName}
              categorySlug={categorySlug}
              subCategoriesCount={subCategories.length}
            />
          ))}
        </div>
      );
    },
  );
